module.exports = __webpack_public_path__ + "img/introduce-sentosa.97b11f83.svg";